<div class="flex flex-col h-full">
  <div class="p-6 flex flex-col gap-4 overflow-y-auto">
    <div class="mb-2 border-b border-border pb-4">
      <app-select
        label="Partner Type"
        [ngModel]="partnerType()"
        (ngModelChange)="partnerType.set($event)"
        [options]="partnerTypeOptions">
      </app-select>
    </div>

    <!-- FMCSA Live Search -->
    <div class="space-y-4">
      <app-text variant="muted" size="sm" class="mb-2">
        Search the Federal Motor Carrier Safety Administration (FMCSA) registry in real-time.
      </app-text>

      <div class="flex flex-col md:flex-row gap-4 items-end">
        <div class="w-full md:w-48 shrink-0">
          <app-select
            label="Search By"
            [ngModel]="fmcsaSearchType()"
            (ngModelChange)="fmcsaSearchType.set($event)"
            [options]="fmcsaTypeOptions">
          </app-select>
        </div>
        <div class="w-full flex-1">
          <app-form-field [label]="fmcsaSearchType() === 'dot' ? 'DOT Number' : 'MC Number'">
            <app-input
              [ngModel]="fmcsaSearchQuery()"
              (ngModelChange)="fmcsaSearchQuery.set($event)"
              [placeholder]="fmcsaSearchType() === 'dot' ? 'e.g. 1234567' : 'e.g. 98765'"
              (keyup.enter)="searchFmcsa()">
            </app-input>
          </app-form-field>
        </div>
        <div class="w-full md:w-auto mt-2 md:mt-0">
          <app-button
            variant="primary"
            [disabled]="!fmcsaSearchQuery() || isSearchingFmcsa()"
            (click)="searchFmcsa()"
            class="w-full md:w-auto block h-10">
            Search
          </app-button>
        </div>
      </div>

      @if (isSearchingFmcsa()) {
        <div class="flex justify-center p-8">
          <lucide-icon name="loader-2" class="w-6 h-6 animate-spin text-muted"></lucide-icon>
        </div>
      }

      @if (fmcsaError()) {
        <div class="p-4 bg-danger/10 border border-danger/20 rounded-lg text-danger text-sm">
          {{ fmcsaError() }}
        </div>
      }

      @if (fmcsaResult()) {
        <div class="mt-4 p-4 bg-surface border border-border rounded-xl shadow-sm flex flex-col gap-3">
          <div class="flex items-start justify-between">
            <div>
              <app-text size="lg" weight="medium" class="block text-foreground">{{ fmcsaResult()?.dbaName || fmcsaResult()?.legalName }}</app-text>
              @if (fmcsaResult()?.dbaName && fmcsaResult()?.legalName) {
                <app-text variant="muted" size="sm" class="block">{{ fmcsaResult()?.legalName }}</app-text>
              }
            </div>
            <span class="px-2.5 py-1 text-xs font-medium rounded-full bg-success/10 text-success border border-success/20">
              Active in FMCSA
            </span>
          </div>

          <div class="grid grid-cols-2 gap-4 pt-3 border-t border-border">
            <div class="flex flex-col">
              <app-text size="xs" color="muted">DOT Number</app-text>
              <app-text size="sm" weight="medium">{{ fmcsaResult()?.dotNumber || '--' }}</app-text>
            </div>
            <div class="flex flex-col">
              <app-text size="xs" color="muted">Address</app-text>
              <app-text size="sm">{{ fmcsaResult()?.address || '--' }}</app-text>
            </div>
          </div>
          
          <div class="mt-2 flex justify-end">
             <app-button variant="primary" (click)="addFmcsaPartner()">Add to Network</app-button>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Footer Actions -->
  <div class="p-4 border-t border-border bg-surface flex justify-end gap-3 mt-auto rounded-b-xl">
    <app-button variant="secondary" (click)="close()">Cancel</app-button>
  </div>
</div>
